import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    popup: {
        body_popup: null,
        btn_popup: null,
        link_popup: null,
        titolo_popup: null,
    }
}

export const popupSlice = createSlice({
    name: 'popup',
    initialState,
    reducers: {
        setPopupBody: (state, action) => {
            state.popup = action.payload;
        },
    },
  });

export const {setPopupBody} = popupSlice.actions;

export const getPopupInfo = (state) => state.popup.popup

export default popupSlice.reducer;